<template>
  <b-form-row>
    <lg-finder ref="finder" :id="this.id" :fields="fields" title="Busca de Local Armazenamento" filterBy="descricao"
      url="/api/local-armazenamento" :othersFilters="othersFilters" @onSelect="onSelect" filtrarSituacao />
  </b-form-row>
</template>

<script>
import LgFinder from "@/core/components/Inputs/LgFinder.vue";

export default {
  components: { LgFinder  },

  props: {
    id: String,
    title: String,
    othersFilters: Array,
  },

  data() {
    return {
      fields: [
         {
          key: "action",
          label: "Ação",
          thClass: "pt-1 pb-0 text-center",
          tdClass: "text-center py-0",
        },
        {
          key: "id",
          label: "Código",
          thClass: "pt-1 pb-0",
          tdClass: "py-0 ",
          isRowHeader: true,
        },
        {
          key: "descricao",
          label: "Descrição",
          thClass: "pt-1 pb-0",
          tdClass: "py-0 ",
        },
        {
          key: "tipoLocalArmazenamento.descricao",
          label: "Tipo",
          thClass: "pt-1 pb-0",
          tdClass: "py-0 ",
        },
      ],
    };
  },

  async mounted() {
  },

  methods: {

    async show() {
      this.$emit("AQUI >>>>");
      await this.$refs.finder.show();
    },
    async onSelect(item) {
      this.$emit("onSelect", item);
      await this.$bvModal.hide(this.id);
    },
  },
};
</script>
